import type { KeyboardEvent } from 'react';

const FOCUSABLES =
  'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

/**
 * Clavier d'une fenêtre `aria-modal` (écart C18) : Tab et Maj+Tab restent dans la fenêtre, Échap la ferme. Fonction pure posée en
 * `onKeyDown`, sans hook : le composant reste appelable directement par les tests qui développent l'arbre.
 */
export function clavierFenetre(e: KeyboardEvent<HTMLElement>, fermer: () => void, occupe: boolean): void {
  if (e.key === 'Escape') {
    e.preventDefault();
    // Pendant l'écriture, rien n'est interrompu : la fenêtre se ferme d'elle-même à la fin.
    if (!occupe) fermer();
    return;
  }
  if (e.key !== 'Tab') return;
  const fenetre = e.currentTarget;
  const elements = [...fenetre.querySelectorAll<HTMLElement>(FOCUSABLES)];
  const premier = elements[0];
  const dernier = elements.at(-1);
  if (!premier || !dernier) {
    e.preventDefault();
    return;
  }
  const actif = fenetre.ownerDocument.activeElement;
  const dehors = !fenetre.contains(actif);
  if (e.shiftKey && (actif === premier || dehors)) {
    e.preventDefault();
    dernier.focus();
  } else if (!e.shiftKey && (actif === dernier || dehors)) {
    e.preventDefault();
    premier.focus();
  }
}
